<template>
  <div
    class="client-assignment tag-wrapper"
    @click="(showTable = false), $emit('transferSuggestions')"
  >
    <p
      @mouseenter="[showTable = true, sendReqForOrigen()]"
      @mouseleave="showTable = false"
      class="bold-it"
    >
      {{ client.assignment.assigned_to.full_name | truncate(8) }}
      <span class="updated-at">{{
        formatDate(client.assignment.updated_at)
      }}</span>
    </p>

    <div class="tag-wrapper">
      <div
        v-if="
          showTable &&
            CheckUserPermission([1, 2, 3, 4, 5, 6, 12]) &&
            logs.length > 0
        "
        class="tag-table"
      >
        <div class="table-responsive">
          <table class="table table-condensed">
            <!--            <thead>
                          <tr class="bg-info">
                            <th>Date</th>
                            <th>Time</th>
                            <th>Assigned By</th>
                          </tr>
                        </thead>-->

            <tbody>
              <span class="title-table mt-5">Team Assignments</span>
              <tr :class="log.assigned_by.full_name == 'Viki' ? 'bg-yellow' : ''" v-for="(log, idx) in logs" :key="idx">
                <td v-if="idx < 7">{{ formatDateTable(log.updated_at) }}</td>
                <td v-if="idx < 7">{{ log.assigned_by.full_name }}</td>
                <td v-if="idx < 7">{{ log.assigned_to.full_name }}</td>
                <td v-if="idx < 7 && log.assigned_by_rank !== null">
                  <b>{{ log.assigned_by_rank }} &#11088;</b>
                </td>
              </tr>
              <span v-if="groupLogs.length > 0" class="title-table"
              >Group Assignments</span
              >
              <tr :class="log.assigned_by.full_name == 'Viki' ? 'bg-yellow' : ''" v-for="(log, idx) in groupLogs" :key="idx">
                <td v-if="idx < 7">{{ formatDateTable(log.updated_at) }}</td>
                <td v-if="idx < 7">{{ log.assigned_by.full_name }}</td>
                <td v-if="idx < 7">{{ log.assigned_to.type }}</td>
              </tr>
                <span  v-if="originLogs" class="title-table">Origin Team Assignments</span>
                <tr v-if="originLogs" v-for="(log, idx) in originLogs" :key="idx">
                  <td v-if="idx < 7">{{ formatDateTable(log.updated_at) }}</td>
                  <td v-if="idx < 7">{{ log.assigned_by.full_name }}</td>
                  <td v-if="idx < 7">{{ log.assigned_to.full_name }}</td>
                  <td v-if="idx < 7 && log.assigned_by_rank !== null">
                    <b>{{ log.assigned_by_rank }} &#11088;</b>
                  </td>
                </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";
import { mapGetters, mapState } from "vuex";
import UsersPermissionCheck from "../../../../../mixins/user/auth/UsersPermissionCheck";
import apiClientCreator from "@/helpers/api/request";

export default {
  name: "client-assignment",
  mixins: [UsersPermissionCheck],
  props: {
    client: {
      type: Object,
      required: true
    },
    logs: {
      type: Array,
      required: true
    },
    groupLogs: {
      type: Array,
      required: true
    },
    isNew: {
      type: Boolean,
      required: true
    },
    inEdit: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      role: 5,
      showTable: false,
      assigned_by: "",
      originLogs: null,
    };
  },

  computed: {
    ...mapState("user", ["auth"]),
  },
  methods: {
    sendReqForOrigen(){

      if(this.client.duplicate  && this.CheckUserPermission([1, 2, 3, 4, 12])) {
        let dupId = this.client.duplicate.client_id;
        const dupAssignRequest = apiClientCreator(
            `client/origin/${dupId}`
        );
        dupAssignRequest.get("", {})
            .then(res => {
             this.originLogs = res.data[0];
        })
      }
    },
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM/YY HH:mm");
    },
    formatDate(date) {
      return moment(String(date)).format("DD/MM/YY");
    }
  }
};
</script>

<style lang="scss" scoped>
.bg-yellow{
  background: #ffffa8;
}
.origin-tr{
  background: #cfd8dc;
}
.is-active {
  background-color: transparent;
}

.tag-wrapper {
  position: relative;
  cursor: pointer;
  text-transform: capitalize;
}

.today {
  background-color: rgba(0, 228, 68, 0.32);
}

.two-days {
  background-color: rgba(255, 255, 0, 0.23);
}

.more-than-three-days {
  background-color: rgba(255, 0, 0, 0.12);
}

.tag-table {
  position: absolute;
  top: -10px;
  left: 0px;
  z-index: 10001;
  width: max-content;
  border: solid 1px #4d4f50;
  border-radius: 5px;
}

.title-table {
  padding: 10px;
  font-size: 13px;
  text-align: left;
}
.tag-wrapper .tag-table .table {
  margin-bottom: unset !important;
}

.table-responsive {
  border-radius: 5px;

  border: 1px solid #dee2e6;
  background: #ffffff !important;
  table tr td {
    padding: 10px 10px 10px 10px;
    margin-top: 2px;
    font-size: 13px !important;
    text-align: left !important;
    border-top: none !important;
    text-align: center;
  }
}

.updated-at {
  float: right;
  font-size: 13px;
}
.tag-wrapper p {
  font-size: 13px;
}
.bold-it {
  /* font-weight: 500; */
}
</style>
